import axios from "axios";
import type BackOfficeConnector from "data/backOfficeConnector";
import type { IPagination } from "data/types";
import CommissionForInvoiceResponse from "entities/commissionForInvoiceResponse";
import type GetCommissionsForInvoiceRequest from "entities/getCommissionsForInvoiceRequest";
import type EventBus from "services/eventBus";
import { serializeFilters } from "utils/filters";
import RepositoryBase from "./repositoryBase";

export default class CommissionsForInvoiceRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAllCommissionsForInvoices(pagination: IPagination, filters: GetCommissionsForInvoiceRequest) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .all("distributors")
          .all("commissions_for_invoice_search")
          .postPagedEntities<CommissionForInvoiceResponse>(
            {
              ...serializeFilters(filters, false),
              ...pagination,
            },
            CommissionForInvoiceResponse
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  async getCommissionsForInvoiceDownload(commissionId: string) {
    const { commissionDetailLink } = await this.callApi(api =>
      api
        .all("call_center")
        .all("distributors")
        .one("commissions_for_invoice", commissionId)
        .all("report")
        .get<{ commissionDetailLink: string }>()
    );

    return axios.get(commissionDetailLink, {
      responseType: "arraybuffer",
    });
  }
}
